// Utils
import useAcl from '@/utils/hooks/user/useAcl';

// Lib
import { aclTemporaryFeatures } from '@/lib/acl/aclFeatures';

export function useNewFunnelActivated() {
    const { hasAcl } = useAcl();
    return { isNewFunnel: hasAcl(aclTemporaryFeatures.publishing.new_funnel.read) };
}
